import { useNavigate, useLocation } from 'react-router-dom'
import { ArrowLeft, Bookmark } from 'lucide-react'
import { useSavedPosts } from '@/hooks/useFeed'
import { mapPostRow } from '@/lib/mapPost'
import PostCard from '@/components/features/feed/PostCard'
import SearchBar from '@/components/ui/SearchBar'

const C = { teal: '#0F5C5C', ink2: '#6D7471', border: '#E1E5E3', grayBg: '#F1F3F2' }
const FH = "'Plus Jakarta Sans', sans-serif"
const FB = "'Inter', sans-serif"

export default function SavedPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const cameFromProfile = (location.state as { from?: string } | null)?.from === 'profile'

  const { data, isLoading } = useSavedPosts()
  const savedPosts = (data?.data ?? []).map((row) =>
    mapPostRow(row, row.business as Record<string, unknown> | undefined)
  )

  return (
    <div style={{ maxWidth: 1100, margin: '0 auto', padding: '28px 28px 60px' }}>
      {cameFromProfile && (
        <button
          onClick={() => navigate(-1)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            border: 'none',
            background: 'transparent',
            cursor: 'pointer',
            color: C.ink2,
            fontFamily: FB,
            fontSize: 14,
            marginBottom: 20,
            padding: 0,
          }}
        >
          <ArrowLeft size={18} /> Volver
        </button>
      )}
      <SearchBar style={{ marginBottom: 20 }} />
      <div
        style={{
          fontFamily: FH,
          fontWeight: 800,
          fontSize: 26,
          letterSpacing: '-0.01em',
          marginBottom: 22,
        }}
      >
        Guardados
      </div>

      {isLoading ? null : savedPosts.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '70px 24px' }}>
          <div
            style={{
              width: 68,
              height: 68,
              borderRadius: 18,
              background: C.grayBg,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 16,
            }}
          >
            <Bookmark size={28} color={C.ink2} />
          </div>
          <div style={{ fontFamily: FH, fontWeight: 700, fontSize: 19, marginBottom: 8 }}>
            Nada guardado aún
          </div>
          <div style={{ fontSize: 14, color: C.ink2, lineHeight: 1.5, marginBottom: 20 }}>
            Toca el ícono de guardar en cualquier publicación para encontrarla aquí.
          </div>
          <button
            onClick={() => navigate('/')}
            style={{
              background: C.teal,
              color: '#fff',
              border: 'none',
              borderRadius: 11,
              padding: '11px 22px',
              fontFamily: FB,
              fontWeight: 700,
              fontSize: 14,
              cursor: 'pointer',
            }}
          >
            Explorar planes
          </button>
        </div>
      ) : (
        <div className="feed-grid">
          {savedPosts.map((p) => (
            <PostCard key={p.id} post={p} initialSaved />
          ))}
        </div>
      )}
    </div>
  )
}
